import { ProjectRepository } from 'core/repositories/ProjectRepository';
import { withProjectRepository } from 'services/useProjectRepository';
import { EnvironmentRepository } from 'core/repositories/EnvironmentRepository';
import { withEnvironmentRepository } from 'services/useEnvironmentRepository';
import { VehicleRepository } from 'core/repositories/VehicleRepository';
import { withVehicleRepository } from 'services/useVehicleRepository';
import { MediaDeviceRepository } from 'core/repositories/MediaDeviceRepository';
import { withMediaDeviceRepository } from 'services/useMediaDeviceRepository';
import { ChannelResolver } from 'core/repositories/ChannelResolver';
import { withChannelResolver } from 'services/useChannelResolver';
import { withCameraLayoutRepository } from 'services/useCameraLayoutRepository';
import { CameraLayoutRepository } from 'core/repositories/CameraLayoutRepository';
import { AuthTokenRepository } from 'core/repositories/AuthTokenRepository';
import { withAuthTokenRepository } from 'services/useAuthTokenRepository';
import { VehicleConfigurationRepository } from 'core/repositories/VehicleConfigurationRepository';
import { withVehicleConfigurationRepository } from 'services/useVehicleConfigurationRepository';
import { VehicleTelemetryRepositoryFactory } from 'core/repositories/FMS/VehicleTelemetryRepository';
import { withVehicleTelemetryRepositoryFactory } from 'services/useVehicleTelemetryRepositoryFactory';
import { withAdaptors } from 'services/utility/withAdaptors';

export type DependencyConfig = {
    projectRepository: ProjectRepository;
    environmentRepository: EnvironmentRepository;
    vehicleRepository: VehicleRepository;
    mediaDeviceRepository: MediaDeviceRepository;
    channelResolver: ChannelResolver;
    cameraLayoutRepository: CameraLayoutRepository;
    authTokenRepository: AuthTokenRepository;
    vehicleConfigurationRepository: VehicleConfigurationRepository;
    vehicleTelemetryRepositoryFactory: VehicleTelemetryRepositoryFactory;
}

export function buildDependencies(deps: DependencyConfig) {
    return withAdaptors(
        withProjectRepository(deps.projectRepository),
        withEnvironmentRepository(deps.environmentRepository),
        withVehicleRepository(deps.vehicleRepository),
        withMediaDeviceRepository(deps.mediaDeviceRepository),
        withChannelResolver(deps.channelResolver),
        withCameraLayoutRepository(deps.cameraLayoutRepository),
        withAuthTokenRepository(deps.authTokenRepository),
        withVehicleConfigurationRepository(deps.vehicleConfigurationRepository),
        withVehicleTelemetryRepositoryFactory(deps.vehicleTelemetryRepositoryFactory),
    );
}
